var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"expande-horizontal elevation-0",attrs:{"color":"#333","dark":"","height":_vm.$vuetify.breakpoint.smAndDown ? '180' : '240'}},[_c('div',{staticClass:"expande-horizontal",staticStyle:{"max-height":"240px"}},[_c('canvas',{attrs:{"height":_vm.$vuetify.breakpoint.smAndDown ? '155' : '110',"id":"myChart"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }